import React from 'react';
import "./DriverPhoto.css"
import {PublicApiDriverSummaryResponse} from "../Representation";

interface DriverPhotoProps {
    apiOrigin: string
    trackingToken: string
    driver: PublicApiDriverSummaryResponse
    circular: boolean
}

const DriverPhoto = (
    props: DriverPhotoProps
) => {

    const { driver } = props;
    const driverFullName = driver.firstName + " " + driver.lastNameInitial;

    return (
        <div className="photo">
            <div className={props.circular ? "circular-image" : ""}>
                <img src={`${props.apiOrigin}/tracking/${props.trackingToken}/driver-photo`} alt={driverFullName} />
            </div>
        </div>
    )

}

export default DriverPhoto;
